import { all } from "redux-saga/effects";
import dashboard from "./dashboard.sagas";
import dashboardKrugman from "./dashboard-krugman.sagas";

export default function* rootSaga() {
  yield all([
    dashboard(),
    dashboardKrugman()
  ])
}